import { inject } from 'vue';
import { elPaginationKey } from './constants.mjs';

const usePagination = () => inject(elPaginationKey, {});

export { usePagination };
//# sourceMappingURL=usePagination.mjs.map
